import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'; // 引入 Vuex Store
import { xlog } from '@/utils/utils';

Vue.use(VueRouter)

// 解决 VueRouter 在 push/replace 重复导航时报错 20250327
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};




const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: () => {
        // 已登录跳 main，否则跳 login
        return store.getters.getLoginedData ? '/main' : '/login';
      }
    },
    { path: '/login', component: () => import('@/pages/LoginPage.vue') },
    { path: '/main', component: () => import('@/pages/MainPage.vue') },
    {
      path: '*',
      redirect: '/', // 所有未知路径回到根
    },
    {
      path: '/fullscreen-view',
      name: 'BigScreen',
      component: () => import('@/pages/BigScreen.vue')
    },
    {
      path: '/data-viewer',
      name: 'DataView',
      component: () => import('@/components/DashBoardPage/DataViewer.vue')
    },
  ]
});



// router.beforeEach((to, from, next) => {
//   const isLoggedIn = !!store.getters.getLoginedData; // 确保是布尔值
//   xlog('是否已登录:', isLoggedIn, '即将前往:', to.path);
//   xlog('设备类型是手机端吗？', isMobile());  // 输出是否判断为手机端

//   if (isLoggedIn) {
//     if (to.path === '/login' || to.path === '/mlogin') {
//       // 已登录但访问登录页，重定向到主页面
//       xlog('已登录，重定向到主页面');
//       const redirectPath = isMobile() ? '/mmain' : '/main'; // 根据设备类型跳转
//       next(redirectPath);
//     } else {
//       // 已登录，正常访问其他页面
//       xlog('已登录，继续前往:', to.path);
//       next();
//     }
//   } else {
//     if (to.path === '/login' || to.path === '/mlogin') {
//       // 未登录，访问登录页，正常放行
//       xlog('未登录，访问登录页面');
//       next();
//     } else {
//       // 未登录，尝试访问受限页面，重定向到登录页
//       if (from.path !== '/login' && from.path !== '/mlogin' && to.path !== from.path) { // 避免重复重定向
//         const loginPath = isMobile() ? '/mlogin' : '/login'; // 根据设备类型选择登录页
//         xlog('未登录，重定向到 ' + loginPath);
//         next(loginPath);
//       } else {
//         next(false); // 取消无意义的导航
//       }
//     }
//   }
// });

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!store.getters.getLoginedData; // 确保是布尔值
  xlog('是否已登录:', isLoggedIn, '即将前往:', to.path);

  if (isLoggedIn) {
    if (to.path === '/login') {
      // 已登录但访问登录页，重定向到主页面
      xlog('已登录，重定向到 /main');
      next('/main');
    } else {
      // 已登录，正常访问其他页面
      xlog('已登录，继续前往:', to.path);
      next();
    }
  } else {
    if (to.path === '/login') {
      // 未登录，访问登录页，正常放行
      xlog('未登录，访问登录页面');
      next();
    } else {
      // 未登录，尝试访问受限页面，重定向到登录页
      if (from.path !== '/login' && to.path !== from.path) { // 避免重复重定向 2025-3-13
        //避免 Navigation cancelled from "/main" to "/login" with a new navigation.
        xlog('未登录，重定向到 /login');
        next('/login');
      } else {
        next(false); // 取消无意义的导航
      }
    }
  }
});



export default router
